define('views/transactions/fee_summary',[
    'backbone',
    'views/_base/baseview',
    'text!views/transactions/fee_summary.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'transaction-fee-summary-container',
        template : _.template(Template),
        tagName  : 'div',
        isRender : true,
        needsAuth: true,
        events   : {},

        initialize: function(options){
            options = options || {};

            this.account_id = options.account_id;
            
            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            setTimeout(function(){

                that.getFees();

            }, 700);

        },

        getFees: function(){
            var that = this;

            $.ajax({
                type       : 'GET',
                url        : pf.url + '/Consumer/Accounts/' + this.account_id + '/FeeSummary',
                async      : false,
                contentType: 'application/json',
                success    : function(response){

                    // console.log('fee_summary success',response);

                    var fee_summary = response.FeeSummary || {},
                        previous_month = fee_summary.PCMF || 0,
                        year_to_date = fee_summary.FTY || 0;

                    $('.js-transaction-fee-previous-month-amount').html(formatCurrency(previous_month));

                    $('.js-transaction-fee-year-to-date-amount').html(formatCurrency(year_to_date));

                },
                error      : function(error){
                    console.log('fee_summary error',error);

                    // pfdialog.alert({
                    //     context: this,
                    //     Body   : ''
                    // });

                }
            });

        }

    });
});
